import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import styles from "./Sidebar.local.scss";

export default class SidebarComponent extends PureComponent {
  static propTypes = {
    content: PropTypes.object.isRequired
  };

  render() {
    const { content, withMask } = this.props;

    const sidebarClasses = classnames(
      styles.sidebar,
      withMask ? styles.withMask : ""
    );

    const contentClasses = classnames(styles.content, "sidebarContent");

    return (
      <div className={sidebarClasses} id="sidebar">
        <div className={contentClasses}>{content}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/SidebarComponent.js